import onGetStatusMobileUsers from './onGetStatusMobileUsers';
import onGetMoreStatusMobileUsers from './onGetMoreStatusMobileUsers';

export default {
  onGetStatusMobileUsers,
  onGetMoreStatusMobileUsers,
};
